import moment from "moment";
const formatDatetime = {
	convertToEST(date) {
		return date.toLocaleString("en-US", {timeZone: "America/New_York"});
	},

	getToday() {
		return this.convertToEST(new Date());
	},

	getLastMonthDay() {
		let d = new Date();
		let newMonth = d.getMonth() - 1;
		if (newMonth < 0) {
			newMonth += 12;
			d.setFullYear(d.getFullYear() - 1);
		}
		d.setMonth(newMonth);
		return this.convertToEST(d);
	},

	getLastYearMonth() {
		let d = new Date();
		let firstDay = moment(new Date(d.getFullYear() - 1, d.getMonth(), 1)).format("YYYY-MM-DD");
		return firstDay;
	},
};

export default formatDatetime;
